import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 9000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  padding: 24px 16px;
`;

export const Modal = styled.div`
  background: #fff;
  border-radius: 10px;
  width: 100%;
  max-width: 640px;
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.18);
`;

export const ModalTitle = styled.h2`
  color: #1b2b3a;
  font-size: 1.15rem;
  font-weight: 700;
  margin: 0;
`;

export const Subtitle = styled.p`
  margin: 0 0 18px;
  font-size: 0.85rem;
  color: #555;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  @media (max-width: 540px) {
    grid-template-columns: 1fr;
  }
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Label = styled.label`
  font-size: 0.85rem;
  font-weight: 600;
  color: #333;
`;

export const Input = styled.input`
  padding: 10px 12px;
  border: 1px solid ${({ $error }) => ($error ? "#e53e3e" : "#e6ecf1")};
  border-radius: 6px;
  font-size: 0.88rem;
  color: #222;
  outline: none;
  background: #fff;
  font-family: inherit;

  &:focus { border-color: ${({ $error }) => ($error ? "#e53e3e" : "#26A9B6")}; }
`;

export const ErrorMsg = styled.p`
  margin: 12px 0 0;
  color: #e53e3e;
  font-size: 0.82rem;
`;

export const ActionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 28px;
`;

export const CancelButton = styled.button`
  padding: 9px 20px;
  border-radius: 6px;
  border: 1.5px solid #26A9B6;
  background: #fff;
  color: #26A9B6;
  font-size: 0.85rem;
  cursor: pointer;

  &:hover { background: #f0fbfc; }
`;

export const SubmitButton = styled.button`
  padding: 9px 20px;
  border-radius: 6px;
  border: none;
  background: #1b6b78;
  color: #fff;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;

  &:hover { background: #175a65; }
  &:disabled { opacity: 0.45; cursor: not-allowed; }
`;
